module.exports = __webpack_public_path__ + "static/media/donbosco5.a89d93a8.jpg";